// Utility to clear authentication state - run this in browser console if needed
export const clearAuthState = () => {
  
  localStorage.removeItem('authToken');
  localStorage.removeItem('user');
  
  window.location.reload();
};

// Debug function to show current auth state
export const debugAuthState = () => {
  if (localStorage.getItem('user')) {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
    } catch (e) {
    }
  }
};

// Debug function to analyze token contents
export const debugToken = () => {
  const token = localStorage.getItem('authToken');
  
  if (token && token.startsWith('demo_token_')) {
  } else if (token && token.includes('|')) {
    const parts = token.split('|');
  } else if (token) {
    try {
      // Try to decode JWT (just for debugging, don't use in production)
      const parts = token.split('.');
      if (parts.length === 3) {
        const payload = JSON.parse(atob(parts[1]));
      }
    } catch (e) {
    }
  }
};

// Function to check what CLAB endpoints expect
export const testClabEndpoints = async () => {
  const token = localStorage.getItem('authToken');
  if (!token) {
    return;
  }
  
  const endpoints = [
    '/clab/dashboard',
    '/clab/pending-biodatas',
    '/clab/pending-applications'
  ];
  
  for (const endpoint of endpoints) {
    try {
      const response = await fetch(`http://localhost:8000/api${endpoint}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        try {
          const errorData = JSON.parse(errorText);
        } catch (e) {
        }
      }
    } catch (error) {
    }
  }
  
};

// Function to test fresh login and API call
export const testFreshLogin = async () => {
  try {
    
    // Clear current auth
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    
    // Fresh login
    const loginResponse = await fetch('http://localhost:8000/api/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username: 'clab1',
        password: 'password'
      })
    });
    
    if (!loginResponse.ok) {
      return;
    }
    
    const loginData = await loginResponse.json();
    
    if (loginData.status === 'success') {
      const token = loginData.data.token;
      const user = loginData.data.user;
      
      // Test CLAB API immediately with fresh data
      const dashboardResponse = await fetch('http://localhost:8000/api/clab/dashboard', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (dashboardResponse.ok) {
        const dashboardData = await dashboardResponse.json();
      } else {
        const errorText = await dashboardResponse.text();
      }
    }
    
  } catch (error) {
  }
};

// Function to test the dashboard after backend fix
export const testDashboardAfterFix = async () => {
  const token = localStorage.getItem('authToken');
  if (!token) {
    return;
  }
  
  try {
    
    const response = await fetch('http://localhost:8000/api/clab/dashboard', {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (response.ok) {
      const data = await response.json();
    } else {
      const errorText = await response.text();
    }
    
  } catch (error) {
  }
};

// Function to test a simple CLAB API call
export const testClabAPI = async () => {
  const token = localStorage.getItem('authToken');
  if (!token) {
    return;
  }
  
  try {
    
    const response = await fetch('http://localhost:8000/api/clab/dashboard', {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (response.ok) {
      const data = await response.json();
    } else {
      const errorText = await response.text();
      
      try {
        const errorData = JSON.parse(errorText);
      } catch (e) {
      }
    }
  } catch (error) {
  }
};

// Make functions available globally for debugging
if (typeof window !== 'undefined') {
  window.clearAuthState = clearAuthState;
  window.debugAuthState = debugAuthState;
  window.debugToken = debugToken;
  window.testClabAPI = testClabAPI;
  window.testFreshLogin = testFreshLogin;
  window.testClabEndpoints = testClabEndpoints;
  window.testDashboardAfterFix = testDashboardAfterFix;
}